import React from 'react'

import { SvgProps } from '../../model/types'

const CheckCircleIcon: React.FC<SvgProps> = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="currentColor"
		{...props}
	>
		<path d="M10.0001 1.66666C14.6024 1.66666 18.3334 5.39761 18.3334 9.99999C18.3334 14.6023 14.6024 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99999C1.66675 5.39761 5.39771 1.66666 10.0001 1.66666ZM10.0001 3.33332C6.31818 3.33332 3.33341 6.31809 3.33341 9.99999C3.33341 13.6819 6.31818 16.6667 10.0001 16.6667C13.682 16.6667 16.6667 13.6819 16.6667 9.99999C16.6667 6.31809 13.682 3.33332 10.0001 3.33332ZM12.9462 6.98436C13.2717 6.65891 13.7993 6.65891 14.1247 6.98436C14.4251 7.28476 14.4482 7.75745 14.1941 8.08436L14.1247 8.16286L9.46966 12.818C9.13724 13.1504 8.61303 13.1742 8.25322 12.8892L8.17326 12.818L5.87516 10.5199C5.54973 10.1945 5.54973 9.66682 5.87516 9.34141C6.17557 9.04094 6.64826 9.01783 6.97517 9.27207L7.05367 9.34141L8.82141 11.1092L12.9462 6.98436Z" />
	</svg>
)

export default CheckCircleIcon
